import { Instagram, Youtube, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { IMG, INSTAGRAM_HANDLE, INSTAGRAM_URL, YOUTUBE_HANDLE, YOUTUBE_URL } from "../site";

const SHOTS = [
    { src: IMG.hero, alt: "Advanced yogasana arm balance" },
    { src: IMG.profile, alt: "Seated backbend asana" },
    { src: IMG.inversion, alt: "Competition-level inversion" },
];

export default function Social() {
    return (
        <section data-testid="social-section" className="relative py-20 sm:py-28 lg:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Eyebrow center>Instagram</Eyebrow>
                <Reveal>
                    <h2 className="mt-6 text-center font-display text-4xl tracking-wide sm:text-5xl lg:text-6xl">
                        FOLLOW THE <span className="text-gold-grad">JOURNEY</span>
                    </h2>
                </Reveal>

                <div className="mt-14 grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-3">
                    {SHOTS.map((shot, i) => (
                        <Reveal
                            key={shot.src}
                            delay={i * 0.1}
                            className={i === 1 ? "col-span-2 lg:col-span-1" : ""}
                        >
                            <a
                                href={INSTAGRAM_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid={`social-tile-${i}`}
                                className="group relative block overflow-hidden rounded-2xl border border-white/10 transition-all duration-500 hover:border-[#F5C542]/60 hover:shadow-[0_18px_50px_-20px_rgba(212,160,23,0.4)]"
                            >
                                <img
                                    src={shot.src}
                                    alt={shot.alt}
                                    className="aspect-square h-full w-full object-cover grayscale contrast-110 transition-transform duration-700 group-hover:scale-105"
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/80 via-transparent to-transparent opacity-60 transition-opacity duration-500 group-hover:opacity-30" />
                                <span className="absolute bottom-4 right-4 flex h-9 w-9 items-center justify-center rounded-full border border-[#F5C542]/50 bg-black/40 opacity-0 backdrop-blur transition-all duration-500 group-hover:opacity-100">
                                    <Instagram size={15} className="text-[#F5C542]" />
                                </span>
                            </a>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2} className="mt-12 flex flex-col items-center gap-4">
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="social-instagram-handle"
                        className="group flex items-center gap-3 text-xl tracking-wide text-white/90 transition-colors hover:text-[#F5C542] sm:text-2xl"
                    >
                        <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#D4A017]/45 bg-[#D4A017]/[0.08] transition-all duration-300 group-hover:shadow-[0_0_24px_rgba(245,197,66,0.4)]">
                            <Instagram size={18} className="text-[#F5C542]" />
                        </span>
                        {INSTAGRAM_HANDLE}
                        <ArrowUpRight
                            size={18}
                            className="text-[#D4A017] transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                        />
                    </a>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="social-cta-follow"
                        className="btn-ghost mt-2"
                    >
                        <Instagram size={15} /> Follow on Instagram
                    </a>
                </Reveal>

                <Reveal delay={0.3} className="mt-10 flex flex-col items-center gap-4">
                    <span className="h-px w-24 bg-gradient-to-r from-transparent via-[#D4A017]/40 to-transparent" />
                    <a
                        href={YOUTUBE_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="social-youtube-handle"
                        className="group flex items-center gap-3 text-xl tracking-wide text-white/90 transition-colors hover:text-[#F5C542] sm:text-2xl"
                    >
                        <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#D4A017]/45 bg-[#D4A017]/[0.08] transition-all duration-300 group-hover:shadow-[0_0_24px_rgba(245,197,66,0.4)]">
                            <Youtube size={18} className="text-[#F5C542]" />
                        </span>
                        YouTube · {YOUTUBE_HANDLE}
                        <ArrowUpRight
                            size={18}
                            className="text-[#D4A017] transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                        />
                    </a>
                    <a
                        href={YOUTUBE_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="social-cta-youtube"
                        className="btn-ghost mt-2"
                    >
                        <Youtube size={15} /> Subscribe on YouTube
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
